import { useQuery } from "@tanstack/react-query";

import { LENDER_RESPONSES_STORE_KEY } from "@krea/customer-features/store/queryClient";
import { IBids } from "@krea/customer-features/types/lenderResponse";

export const useGetCachedLenderResponses = (
  loanApplicationID: string | undefined,
) => {
  return useQuery<IBids>({
    queryKey: [LENDER_RESPONSES_STORE_KEY, loanApplicationID],
    enabled: false,
  });
};
